module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"step":"Настройка приглашения кандидатов","next":"Далее","saveDraft":"Сохранить черновик","integrationsTip":"Huntica автоматически импортирует отклики кандидатов с Работа.ру.<br> Чтобы кандидаты смогли записать видеоотклик, им необходимо отправить приглашение.","lostInfoWarning":"Все изменения будут потеряны. Вы уверены?","continue":"Продолжить редактирование","goBack":"Назад"}}')
  delete Component.options._Ctor
}
